
import { address, email, mobile_no } from '../../constants/themeConstants'
import React,{useState} from 'react'
import {AiOutlineMail} from 'react-icons/ai'
import {IoMdCall} from 'react-icons/io'
import {IoLocationOutline} from 'react-icons/io5'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ErrorComponent from '../../constants/ErrorComponent'
import toast from 'react-hot-toast'



function Location() {

  const navigator = useNavigate()

  const [data,setdata] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})
  const [error,seterror] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  const branches = [
    {
      name:"Mumbai",
      location:"No.606/7 Sagartech Plaza B wing,Sakinaka Junction, Andheri-Kurla Road,Mumbai- 400072"
    },
    {
      name:"Chennai",
      location:"6/2, CASA Major Rd, Egmore,Chennai, Tamil Nadu 600008"
    },
    {
      name:"Pune",
      location:"Kothari Plaza,Bibwewadi-Kondwa, Rd,Lullanagar„ Pune, Maharashtra-411040"
    },
    {
      name:"Hyderabad",
      location:"No.2 Banjara Hills, Annapurna Studios Lane, Hyderabad, Telangana 500034"
    },
    {
      name:"Shivamogga",
      location:"Keonics IT Park, Machenahalli, Shivamogga, Karnataka 577222"
    },
    {
      name:"Kolkata",
      location:"Express Tower, 42A, Shakespeare Sarani Rd, Elgin, Kolkata, West Bengal 700017"
    },
    {
      name:"Ahmedabad",
      location:"Astron Tech Park, Satellite Rd,  Ahmadabad, Gujarat – 380015"
    }
  ]

  async function submitData() {
    if(!data.name){
      seterror({...error,name:'This Field is required*'})
    }else if(!data.mobile){
      seterror({...error,mobile:'This Field is required*'})
    }else if(!data.email){
      seterror({...error,email:'This Field is required*'})
    }else if(!data.requirment){
      seterror({...error,requirment:'This Field is required*'})
    }else{
      let sendData = {...data}
      sendData['department_website'] = 'Corp Team'
      const response = await axios.post(`https://fidelitustech.com/api/clients/create`,sendData)
      // console.log("response",response?.data?.status)
      if(response?.status == 201){
        toast.success("Your Query Submitted Successfully!")
        resetForm()
      }
    }
  }


  const location = [
    {
        name:'Main Church',
        timing:'7:00am • 09:30am • 06:00pm',
        address:'9th C – Main Road, 4th Cross, Mariyappana Palya, K. P. Agrahara, Bengaluru, Karnataka 560023.',
        link:'https://www.google.com/maps?ll=12.970032,77.56147&z=11&t=m&hl=en-US&gl=US&mapclient=embed&cid=5319018801701974004'
    },
    {
        name:'Kamalanagar Church',
        timing:'9:00am • 06:00pm',
        address:'Mani Vilas Garden, #45/2, 3rd Main Rd, Kamalanagar, Basaveshwar Nagar, Bengaluru, Karnataka 560079',
        link:'https://www.google.com/maps?ll=12.992706,77.527838&z=11&t=m&hl=en-US&gl=US&mapclient=embed&cid=7752176074924499455'
    },
    {
        name:'Nandhini Layout Church',
        timing:'9:00am',
        address:'Kempamma Layout, Lakshmi Devi Nagar, Kaveri Nagar, Bengaluru, Karnataka 560058',
        link:'https://www.google.com/maps/place/2G7H%2BPGV,+Kempamma+Layout,+Lakshmi+Devi+Nagar,+Kaveri+Nagar,+Bengaluru,+Karnataka,+India/@13.014363,77.528797,11z/data=!4m5!3m4!1s0x3bae3d089161fff3:0xde43f022bd522a5d!8m2!3d13.0143625!4d77.5287969?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D'
    },
    {
        name:'Ullal Uppanagar Church',
        timing:'7:00am',
        address:'Sir M Vishweshwaraiah Layout 6th Block, Ullal Uppanagar, Bengaluru, Karnataka 560110',
        link:'https://www.google.com/maps?ll=12.963633,77.472601&z=11&t=m&hl=en-US&gl=US&mapclient=embed&cid=284017960026325836'
    },
    {
        name:'Kalanakuppe Church',
        timing:'9:00am',
        address:'Anekal Road, Banavasi, Kallanakuppe, Karnataka 562121',
        link:'https://www.google.com/maps?ll=12.635338,77.566371&z=11&t=m&hl=en-US&gl=US&mapclient=embed&q=Anekal+Road+Karnataka'
    },
    {
        name:'Ashwath Nagar Church',
        timing:'9:00am',
        address:'Saraipalya, Manayata Tech Park, Sinthan Nagar, Bengaluru, Karnataka 560045',
        link:'https://www.google.com/maps?ll=13.052913,77.626172&z=11&t=m&hl=en-US&gl=US&mapclient=embed&q=3J3G%2B5F7+Saraipalya,+Manayata+Tech+Park,+Sinthan+Nagar+Bengaluru,+Karnataka+560077'
    },
    {
        name:'Doddabalpur Church',
        timing:'9:00am',
        address:'Kantanakunte, Vaddarahalli, Karnataka 561205',
        link:'https://www.google.com/maps?ll=13.335563,77.532859&z=11&t=m&hl=en-US&gl=US&mapclient=embed&q=8GPM%2B64H+Kantanakunte,+Karnataka+561203'
    },
    {
        name:'Ashrayanagar Church',
        timing:'9:00am',
        address:'Annapurneshwari Nagar Road, Annapurneshwari Nagar, Yeshwanthpur Suburb II Stage, Yesvanpur Surburb, Peenya, Vaddarapalya, Bengaluru, Karnataka 560058',
        link:'https://www.google.com/maps/place/Sri+byraveshwara+industries/@13.014303,77.492375,11z/data=!4m6!3m5!1s0x3bae3c8cb9cf7473:0x244a6612bd9b6071!8m2!3d13.0143033!4d77.4923754!16s%2Fg%2F1ptxb52s4?hl=en-US&entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D'
    },
    {
        name:'Belalam Church',
        timing:'9:00am',
        address:'Achubalu, Tamil Nadu 635118',
        link:'https://www.google.com/maps?ll=12.557513,77.597328&z=11&t=m&hl=en-US&gl=US&mapclient=embed&q=HH5W%2B2W4+Achubalu,+Tamil+Nadu'
    },
  ]


  function openMap(link) {
    window.open(link, '_blank', 'noopener,noreferrer');
  }

  function resetForm(){
    setdata({name:'',email:'',mobile:'',requirment:'',department_website:''})
    seterror({name:'',email:'',mobile:'',requirment:'',department_website:''})
  }

  return (
    <div className='w-screen h-full bg-gray-50'>
      <div className="bg-banner8 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-center">
        <h1 className="bg-[#7b026b]/30 z-10 w-max px-10 py-2 md:py-5 text-[16px] text-white md:text-[20px] uppercase font-heading">
          Location
        </h1>
        <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
        </div>
       </div> 

      <div className='w-[90%] md:w-[80%] mx-auto py-10'>
        <h1 data-aos="fade-right" className='text-[18px] 2xl:text-[21px] font_normal'>Visit our branch church with the below mentioned address for praise the lord together!.</h1>
        
        <div className='grid grid-cols-1 md:grid-cols-4 my-10 gap-4'>
            {location?.map((l,i)=>(
               <div data-aos="fade-up" key={i} className='border p-2'>
                <h6 className='font-heading text-[15px] text-[#7b026b]'>{l?.name}</h6>
                <h6 className='text-[14px] font-body'>Timings : <span className='font-heading text-[10px]'>{l?.timing}</span></h6>
                <h6 className='text-[14px] font-body'>{l?.address}</h6>
                 <h6 onClick={()=>openMap(l?.link)} className='bg-gray-100 cursor-pointer transition-all mt-1 duration-500 w-max md:w-[80px] text-[12px] 2xl:text-[15px] text-center px-2 py-1 font_normal hover:bg-black hover:text-white'>View Map</h6>
               </div> 
            ))}

        </div>


      </div>   
    </div>
  )
}

export default Location